module.exports = __webpack_public_path__ + "img/icon-previous.11c68ec6.svg";